import React, {useEffect, useState} from 'react';
import Loading from "./Loading";
import {getConversationFriendlyName} from "./utils";
import {Text} from "./styles";
import {showErrorToast} from "../Utilities";
import {useChatTrackedState} from "./store";


type Props = {
    conversation: any;
    kind: string;
}

const ChannelTitle: React.FC<Props> = ({conversation, kind}) => {
    const [stateTitle, setStateTitle] = useState({
        loading: kind === 'Duo',
        channelName: conversation.friendlyName ? conversation.friendlyName : 'N/A'
    });
    const {loading, channelName} = stateTitle;
    const {conversationClient} = useChatTrackedState();

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on('updated', ({conversation}) => {
                if (conversation && conversation.friendlyName && conversation.attributes) {
                    // @ts-ignore
                    if (conversation.attributes.kind === 'Group') {
                        // @ts-ignore
                        setStateTitle(currState => ({...currState, channelName: conversation.friendlyName}))
                    }
                }
            });
            getConversationFriendlyName(conversation, conversationClient)
                .then((name) => {
                    setStateTitle(({loading: false, channelName: name}));
                })
                .catch(async (e) => {
                    setStateTitle(currState => ({...currState, loading: false}))
                    await showErrorToast(e, 'Error in Channel Name.');
                });
        }
        return () => {
            abortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (<Loading imgHeight={'15px'} containerHeight={'18px'}/>);
    }

    return (
        <Text height={'18px'}
              fontSize={channelName && channelName.length >= 22 ? '11px' : '14px'}>{channelName}</Text>);
}

function propsAreEqual(prev, next) {
    return prev.conversation.sid === next.conversation.sid;
}

const MemoizedChannelTitle = React.memo(ChannelTitle, propsAreEqual);
// export default ChannelTitle;
export default MemoizedChannelTitle;